/**
 * Core-data dimensions that participate in permission-set scoping. Each maps to
 * one `scope_dimension` object per organisation and to the catalogue table whose
 * row ids become `scope_value` object ids (departments.id / subsidiaries.id).
 */
export const CORE_DATA_DIMENSIONS = ['department', 'subsidiary'] as const

/** A core-data dimension participating in permission-set scoping. */
export type CoreDataDimension = (typeof CORE_DATA_DIMENSIONS)[number]
